<template>
  <v-container id="traffic-control" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12" md="5">
        <base-material-card
          color="#018C74"
          icon="mdi-traffic-cone"
          class="glass-card full-height"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">
              TRAFFIC CONTROL CENTER
            </div>
            <div class="subtitle-2 secondary-text">
              Manajemen Penutupan & Pengalihan Arus
            </div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-row dense>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.judul"
                  label="Judul Skenario"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-map-marker-alert"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.keterangan"
                  label="Penyebab Penutupan (Info Kiri Atas)"
                  outlined
                  color="#ff5252"
                  rows="2"
                  prepend-inner-icon="mdi-comment-remove-outline"
                />
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="editedItem.rute_alternatif_desc"
                  label="Deskripsi Jalur Alternatif (Info Kiri Bawah)"
                  outlined
                  color="#018C74"
                  rows="2"
                  prepend-inner-icon="mdi-directions-fork"
                />
              </v-col>

              <v-col cols="12" class="text-center my-4">
                <div class="white--text text-overline mb-2">MODE MAPPING PETA</div>
                <v-btn-toggle v-model="mappingMode" mandatory color="#CFA22D">
                  <v-btn value="CLOSED" small>
                    <v-icon left color="#ff5252">mdi-close-network</v-icon>
                    GAMBAR JALUR TUTUP
                  </v-btn>
                  <v-btn value="ALT" small>
                    <v-icon left color="#018C74">mdi-vector-polyline</v-icon>
                    GAMBAR ALTERNATIF
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>

            <v-card-actions class="px-0 pt-4">
              <v-btn text color="rgba(255,255,255,0.6)" @click="clearForm"
                >RESET MAP</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="#CFA22D"
                class="cyber-save-btn"
                :loading="loading"
                @click="save"
              >
                <v-icon left>mdi-sync-circle</v-icon> SIMPAN DATA
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="7">
        <base-material-card color="#CFA22D" icon="mdi-map-marker-path" class="glass-card">
          <div class="map-wrapper">
            <div id="map-traffic-full" class="cyber-map-container light-map"></div>

            <transition name="slide-x">
              <div v-if="closedCoords.length > 0" class="map-overlay-info top-left-info">
                <div class="overlay-label mb-1">DATA PENUTUPAN</div>
                <div class="overlay-title red--text text--lighten-2">
                  {{ editedItem.judul || "Tanpa Nama" }}
                </div>
                <div class="overlay-body">
                  {{ editedItem.keterangan || "Belum ada deskripsi penutupan." }}
                </div>
              </div>
            </transition>

            <transition name="slide-x">
              <div v-if="altCoords.length > 0" class="map-overlay-info bottom-left-info">
                <div class="overlay-label mb-1">RUTE ALTERNATIF</div>
                <div class="overlay-body">
                  {{ editedItem.rute_alternatif_desc || "Belum ada deskripsi rute." }}
                </div>
              </div>
            </transition>

            <div class="map-stats-overlay">
              <div class="stat-item">
                <v-icon x-small color="#ff5252" class="mr-1">mdi-square</v-icon> Tutup
              </div>
              <div class="stat-item">
                <v-icon x-small color="#018C74" class="mr-1">mdi-square</v-icon>
                Alternatif
              </div>
            </div>
          </div>
        </base-material-card>
      </v-col>

      <v-col cols="12">
        <base-material-card
          color="#018C74"
          icon="mdi-database-eye"
          class="glass-card mt-6"
        >
          <v-data-table
            :headers="headers"
            :items="rekayasaList"
            :search="search"
            :loading="loading"
            class="cyber-table"
          >
            <template v-slot:item.judul="{ item }">
              <span class="white--text font-weight-bold">{{ item.judul }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon color="#018C74" @click="editItem(item)" class="mr-2">
                <v-icon small>mdi-circle-edit-outline</v-icon>
              </v-btn>
              <v-btn icon color="#ff5252" @click="deleteItem(item)">
                <v-icon small>mdi-delete-alert-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const BASE_URL = "https://berkah.bondowosokab.go.id:5500";

export default {
  data: () => ({
    search: "",
    loading: false,
    mappingMode: "CLOSED",
    map: null,
    closedCoords: [],
    altCoords: [],
    layerClosed: null,
    layerAlt: null,
    altInterval: null,
    rekayasaList: [],
    headers: [
      { text: "IDENTITAS REKAYASA", value: "judul" },
      { text: "PENYEBAB", value: "keterangan" },
      { text: "KONTROL", value: "actions", align: "end", sortable: false },
    ],
    editedItem: {
      id: null,
      judul: "",
      keterangan: "",
      rute_alternatif_desc: "",
      status: 1,
    },
    defaultItem: {
      id: null,
      judul: "",
      keterangan: "",
      rute_alternatif_desc: "",
      status: 1,
    },
  }),

  mounted() {
    this.initMap();
    this.fetchData();
  },

  methods: {
    initMap() {
      setTimeout(() => {
        this.map = L.map("map-traffic-full", { zoomControl: false }).setView(
          [-7.9135, 113.8215],
          13
        );
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png"
        ).addTo(this.map);

        this.map.on("click", (e) => {
          const newCoord = [e.latlng.lat, e.latlng.lng];
          if (this.mappingMode === "CLOSED") {
            this.closedCoords.push(newCoord);
          } else {
            this.altCoords.push(newCoord);
          }
          this.drawLayers();
        });
      }, 500);
    },

    drawLayers() {
      if (this.layerClosed) this.map.removeLayer(this.layerClosed);
      if (this.layerAlt) this.map.removeLayer(this.layerAlt);

      if (this.closedCoords.length > 1) {
        this.layerClosed = L.polyline(this.closedCoords, {
          color: "#ff5252",
          weight: 8,
          dashArray: "10, 15",
          opacity: 0.8,
        }).addTo(this.map);
      }

      if (this.altCoords.length > 1) {
        this.layerAlt = L.polyline(this.altCoords, {
          color: "#018C74",
          weight: 6,
          dashArray: "1, 15",
          opacity: 1,
        }).addTo(this.map);
        this.startAnimation();
      }
    },

    startAnimation() {
      let offset = 0;
      if (this.altInterval) clearInterval(this.altInterval);
      this.altInterval = setInterval(() => {
        offset++;
        if (this.layerAlt) this.layerAlt.setStyle({ dashOffset: -offset });
      }, 50);
    },

    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(`${BASE_URL}/traffic-rekayasa`);
        this.rekayasaList = res.data?.response?.data || res.data || [];
      } catch (e) {
        console.error("Fetch Error:", e);
      } finally {
        this.loading = false;
      }
    },

    async save() {
      if (!this.editedItem.judul) return alert("Judul skenario wajib diisi!");
      this.loading = true;

      const payload = {
        judul: this.editedItem.judul,
        keterangan: this.editedItem.keterangan,
        rute_alternatif_desc: this.editedItem.rute_alternatif_desc,
        coords_closed: JSON.stringify(this.closedCoords),
        coords_alt: JSON.stringify(this.altCoords),
        status: this.editedItem.status || 1,
      };

      try {
        if (this.editedItem.id) {
          await axios.put(`${BASE_URL}/traffic-rekayasa/${this.editedItem.id}`, payload);
        } else {
          await axios.post(`${BASE_URL}/traffic-rekayasa`, payload);
        }
        alert("Sinkronisasi Database Berhasil!");
        this.fetchData();
        this.clearForm();
      } catch (e) {
        alert("Gagal menghubungi server pusat!");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm(`Hapus skenario rekayasa: ${item.judul}?`)) {
        try {
          await axios.delete(`${BASE_URL}/traffic-rekayasa/${item.id}`);
          this.fetchData();
          if (this.editedItem.id === item.id) this.clearForm();
        } catch (e) {
          alert("Gagal menghapus data dari server.");
        }
      }
    },

    clearForm() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.closedCoords = [];
      this.altCoords = [];
      if (this.altInterval) clearInterval(this.altInterval);
      this.drawLayers();
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.closedCoords = item.coords_closed ? JSON.parse(item.coords_closed) : [];
      this.altCoords = item.coords_alt ? JSON.parse(item.coords_alt) : [];

      this.drawLayers();
      if (this.closedCoords.length) {
        this.map.fitBounds(this.closedCoords, { padding: [50, 50] });
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.cyber-page {
  background: transparent;
}
.cyber-text {
  letter-spacing: 2px !important;
  color: white !important;
}
.secondary-text {
  color: #cfa22d !important;
}

.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.map-wrapper {
  position: relative;
  padding: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid #cfa22d;
  overflow: hidden;
}
.cyber-map-container {
  height: 500px;
  width: 100%;
  border-radius: 4px;
}

.map-overlay-info {
  position: absolute;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(4px);
  padding: 12px;
  width: 240px;
  border-left: 4px solid #cfa22d;
  pointer-events: none;
}

.top-left-info {
  top: 20px;
  left: 20px;
  border-left-color: #ff5252;
}
.bottom-left-info {
  bottom: 20px;
  left: 20px;
  border-left-color: #018c74;
}

.overlay-label {
  font-size: 9px;
  color: #aaa;
  letter-spacing: 1px;
  font-weight: bold;
}
.overlay-title {
  font-size: 14px;
  font-weight: 900;
  line-height: 1.2;
  margin-bottom: 4px;
}
.overlay-body {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
}

.map-stats-overlay {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.8);
  padding: 8px;
  border: 1px solid #cfa22d;
  border-radius: 4px;
}
.stat-item {
  color: white;
  font-size: 10px;
  font-family: monospace;
}

.slide-x-enter-active,
.slide-x-leave-active {
  transition: all 0.4s ease;
}
.slide-x-enter,
.slide-x-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}

.cyber-save-btn {
  color: #002616 !important;
  font-weight: 900 !important;
}
.cyber-table {
  background: transparent !important;
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
